export type PageKey =
  | "home"
  | "users"
  | "fakturering"
  | "rapporter"
  | "productTypesAdmin"
  | "bugBoard"
  | "vidareforsaljning"
  | "kunder"
  | "certificates";
export type MenuEntry = { key: PageKey; label: string; visible?: () => boolean };

export const PAGE_PATHS: Record<PageKey, string> = {
  home: "/",
  users: "/users",
  fakturering: "/fakturering",
  rapporter: "/rapporter",
  productTypesAdmin: "/product-types",
  bugBoard: "/bug-board",
  vidareforsaljning: "/vidareforsaljning",
  kunder: "/kunder",
  certificates: "/certificates",
};

export function buildMenu(user: { role?: string | null } | null): MenuEntry[] {
  const isAdmin = (user?.role || "").toString() === "admin";
  const isCustomer = (user?.role || "").toString() === "customer";
  return [
    { key: "home", label: "Hem" },
    { key: "certificates", label: "Raderingscertifikat", visible: () => !isCustomer },
    { key: "kunder", label: "Kunder", visible: () => !isCustomer },
    { key: "users", label: "Användare", visible: () => isAdmin },
    { key: "fakturering", label: "Fakturering", visible: () => !isCustomer },
    { key: "vidareforsaljning", label: "Vidareförsäljning", visible: () => !isCustomer },
    { key: "productTypesAdmin", label: "Produkttyper (Admin)", visible: () => isAdmin },
    { key: "bugBoard", label: "Bug Board", visible: () => isAdmin },
    { key: "rapporter", label: "Rapporter" },
  ];
}

export function pageKeyToPath(
  key: PageKey,
  opts?: { reportsView?: "fakturor" | "klimat" }
): string {
  if (key === "rapporter") {
    return opts?.reportsView === "klimat" ? "/rapporter/klimat" : "/rapporter";
  }
  return PAGE_PATHS[key] ?? "/";
}

export function pathToPage(pathname: string): PageKey {
  if (pathname.startsWith("/kunder")) return "kunder";
  if (pathname.startsWith("/rapporter")) return "rapporter";
  if (pathname.startsWith("/certificates")) return "certificates";
  const hit = Object.entries(PAGE_PATHS).find(([, path]) => path === pathname);
  if (hit) return hit[0] as PageKey;
  return "home";
}

export function reportsViewFromPath(pathname: string): "fakturor" | "klimat" {
  return pathname.startsWith("/rapporter/klimat") ? "klimat" : "fakturor";
}
